"use client";

import { trackEvent } from "@/lib/analytics";
import type { HubSportKey } from "@/lib/conditions/hub/types";
import { HUB_SPORT_PARAM, selectHubSport as writeHubSport } from "./hub-sport-state";

/** The hub board card's element id (search scrolls to it after choosing a sport). */
export const HUB_BOARD_ID = "hub-board";
/** The shareable board choice: `/conditions?sport=<key>` (the canonical stays `/conditions`). */
export { HUB_SPORT_PARAM };

export type HubSportSelectSource = "pin" | "sheet" | "search";

/**
 * Select a hub sport (null for All) from a board control or search: the shared shallow `?sport=`
 * write in `hub-sport-state.ts` (which also notifies the other islands), plus analytics.
 */
export function selectHubSport(sport: HubSportKey | null, source: HubSportSelectSource): void {
  writeHubSport(sport, "replace");
  trackEvent("conditions_hub_sport_select", { sport: sport ?? "all", source });
}
